import * as React from 'react';
import './preferences-page.component.css';
import Page from "../../../components/core/Page";
import {Customer} from "../../../models";
import Input, {FormFieldInputs} from "../../../components/input/Input";
import FormSubmitButton from "../../../components/common/FormSubmitButton";
import {IonButton} from "@ionic/react";

type PreferencesPageProps = {
    customer?: Customer | null;
    preferencesForm: any;
    preferencesFormFieldInputs: FormFieldInputs;
    onSubmitPreferences: (data: any) => void;
    onBackClicked: () => void;

    // Loading states
    isFetching: boolean;
    isLoading: boolean;
};

export const PreferencesPage: React.FC<PreferencesPageProps> = (props) => {
    const {
        preferencesForm,
        preferencesFormFieldInputs,
        onSubmitPreferences,
        onBackClicked,
        isFetching,
        isLoading,
    } = props;
    const {handleSubmit, register, control, formState: {errors}} = preferencesForm;

    // Disable Save while fetching OR while a save is in flight (isLoading = isSaving),
    // so hammering Save can't fire multiple POSTs.
    const isBusy = isFetching || isLoading;

    const formRef = React.useRef<HTMLFormElement>(null);

    const triggerSave = () => {
        if (formRef.current && !isBusy) {
            formRef.current.requestSubmit();
        }
    };

    return (
        <Page
            className={"preferences-page ion-text-center"}
            title={'Preferences'}
            showBackButton={true}
            showMenuButton={false}
            showLoading={isFetching}
            topRightButton={<IonButton className="ion-color text-semi-bold" slot="end" fill="clear"
                                       disabled={isBusy}
                                       onClick={() => triggerSave()}
            >Save</IonButton>}
        >
            <>
                <form ref={formRef} onSubmit={handleSubmit(onSubmitPreferences)}>
                    {Object.entries(preferencesFormFieldInputs).map(([_fieldName, field], index) => (
                        <Input
                            key={index}
                            {...field}
                            control={control}
                            register={register}
                            errors={errors}
                            isDisabled={isFetching}
                        />
                    ))}
                    <FormSubmitButton
                        outerClassName={"ion-text-center ion-margin-top"}
                        disabled={isBusy}
                    >
                        Save
                    </FormSubmitButton>
                </form>

                <IonButton className="ion-margin-bottom" onClick={onBackClicked} fill="clear">
                    Back
                </IonButton>
            </>
        </Page>
    );
};
